import React from 'react';

/**
 * Render de Controller para campos ocultos de texto/número.
 * Evita TextField type="hidden" de MUI v5, que dibuja un recuadro vacío.
 */
export function renderHiddenInput({ field }) {
  const {
    ref, value, onChange, onBlur, name,
  } = field;

  return (
    <input
      type="hidden"
      ref={ref}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      value={value ?? ''}
    />
  );
}

/**
 * Render de Controller para booleanos/objetos gestionados solo con setValue.
 */
export function renderHiddenRegister() {
  return null;
}
